module.exports = __webpack_public_path__ + "static/media/gender-strawberry.db9d03dc.PNG";